import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API_URL from '../config/api';
import AuthShell, { inputClass, primaryButtonClass, ErrorBox } from '../components/AuthShell';

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/password-reset/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || data.email?.[0] || data.detail || t('common.genericError'));
      }
      setSent(true);
    } catch (err: any) {
      setError(err.message || t('common.genericError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t('reset.requestTitle')} subtitle={sent ? undefined : t('reset.requestBody')}>
      {sent ? (
        <div className="bg-white shadow rounded-lg p-6 text-center space-y-4">
          <p className="text-sm text-gray-700">{t('reset.sent')}</p>
          <Link to="/login" className="text-sm font-medium text-blue-600">{t('reset.backToLogin')}</Link>
        </div>
      ) : (
        <form className="space-y-4" onSubmit={handleSubmit}>
          <ErrorBox message={error} />
          <input
            type="email"
            required
            className={inputClass}
            placeholder={t('reset.email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <button type="submit" disabled={loading} className={primaryButtonClass}>
            {loading ? t('reset.sending') : t('reset.send')}
          </button>
          <p className="text-center text-sm">
            <Link to="/login" className="text-blue-600">{t('reset.backToLogin')}</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPassword;
